module.exports = __webpack_public_path__ + "img/natgeothumb.bbdd8afe.jpg";